import React from 'react';
import { Column } from '@prisjakt/ui/list/variants';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import DataContainer from '../../../../components/data';
import Loader from '../../../../components/loader';
import { CreateAlert } from '../create-alert';
import productAlertFormQuery from './productAlertFormQuery.graphql';
import ErrorMessage from '../../../../components/error-message';

import { ProductAlertFormData } from '../../types';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Title, Wrapper } from './styles';

const ProductAlertModalContent = (props: ProductAlertModalContentProps) => {
  const { productId, hideModal, privacyPolicyUri } = props;
  const { t } = useAppContext();
  const renderError = () => <ErrorMessage />;
  const renderLoader = () => <Loader fadeIn />;
  const variables = { id: productId };

  const renderCallback = React.useCallback(
    ({ data }: RenderProps) => {
      const isEdit = Boolean(data?.product?.alert?.id);

      return (
        <Wrapper>
          <Title>
            <TitleMediumText>
              {isEdit
                ? t('product', 'alert.title-edit')
                : t('product', 'alert.title')}
            </TitleMediumText>
          </Title>
          <Column gap={1}>
            <CreateAlert
              productAlertFormData={data}
              privacyPolicyUri={privacyPolicyUri}
              isEdit={isEdit}
              onClose={hideModal}
            />
          </Column>
        </Wrapper>
      );
    },
    [hideModal, privacyPolicyUri, t]
  );

  return (
    <DataContainer
      query={productAlertFormQuery}
      renderLoader={renderLoader}
      variables={variables}
      render={renderCallback}
      renderError={renderError}
    />
  );
};

interface ProductAlertModalContentProps {
  productId?: number;
  withoutGraph?: boolean;
  hideModal: () => void;
  privacyPolicyUri?: string;
}

interface RenderProps {
  data: ProductAlertFormData;
}

export default ProductAlertModalContent;
